export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $modal = document.querySelectorAll('.showSocialIconModal-trigger');

        if (!$modal) {
            return;
        }

        // eslint-disable-next-line
        Array.prototype.slice.call($modal).forEach(function ($modal) {
            // eslint-disable-next-line
            $modal.addEventListener('click', () => {
                const url = $modal.getAttribute('href');
                window.open(url);
            }, false);
        });
    });
}
